import React from 'react';
import SVG from "react-inlinesvg";
import {Modal} from "react-bootstrap";
import {toAbsoluteUrl} from "../../../../../../../_metronic/_helpers";
import {NavLink} from 'react-router-dom';
import {diffCheck, formatAmount} from '../../../../../../util/Helpers';
import ErrorMessage from './ErrorMessage';
import {useGetPaymentQuery} from "../../../../../../../redux/apiSlice";

const PaymentAction = ({show, action: {action, error, data}, onHide}) => {
    const {isFetching, data: payment} = useGetPaymentQuery(data?.paymentId)

    return <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
    >
        <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
                <span className={`svg-icon svg-icon-lg svg-icon-danger mr-3`}>
                    <SVG
                        title=""
                        src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart3.svg")}
                    />
                </span> {action}
            </Modal.Title>
            <button type="button" className="close" onClick={onHide}>
                <span aria-hidden="true" className="d-block">×</span>
                <span className="sr-only">Close</span>
            </button>
        </Modal.Header>
        <Modal.Body>
            <ErrorMessage {...{error}} />
            {isFetching && <div className="text-center py-10">
                <div className={`spinner-border mx-auto text-primary ${!isFetching ? "d-none" : ""}`}
                     style={{width: "4rem", height: "4rem", borderWidth: "0.1rem"}} role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>}
            {!isFetching && <div className="px-md-5">
                <div className="row">
                    <div className="col-md-4 h6">
                        User
                    </div>
                    <div className="col-md h6 text-muted">
                        <NavLink to={`/users/view/${payment?.userId}`} target="_blank">
                            {data?.username ?? ""}
                        </NavLink>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Account Id
                    </div>
                    <div className="col-md h6 text-muted">
                        <NavLink
                            to={`/users/view/${payment?.data?.meta?.userId}/account-information/${payment?.data?.accountId}`}
                            className="text-muted text-hover-primary" target="_blank">
                            {payment?.data?.accountId}
                        </NavLink>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Gateway
                    </div>
                    <div className="col-md h6 text-muted">
                        {payment?.data?.gateway}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Type
                    </div>
                    <div className="col-md h6 text-muted">
                        {payment?.data?.type}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Status
                    </div>
                    <div className="col-md h6 text-muted">
                        {diffCheck(data.meta.status, data?.status)}
                    </div>
                </div>
                <div className={`row mt-4 ${payment?.data.amount ? "" : "d-none"}`}>
                    <div className="col-md-4 h6">
                        Amount
                    </div>
                    <div className="col-md h6 text-muted">
                        {formatAmount(payment?.data?.currency, payment?.data?.amount)}
                    </div>
                </div>
                <div className={`row mt-4 ${payment?.data?.price ? "" : "d-none"}`}>
                    <div className="col-md-4 h6">
                        Price
                    </div>
                    <div className="col-md h6 text-muted">
                        {formatAmount(payment?.data?.currency, payment?.data?.price)}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Service Fee
                    </div>
                    <div className="col-md h6 text-muted">
                        {formatAmount(payment?.data?.currency, payment?.data?.serviceFee)}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Total
                    </div>
                    <div className="col-md h6 text-muted">
                        {formatAmount(payment?.data?.currency, payment?.data?.total)}
                    </div>
                </div>
            </div>}
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
            <button
                type="button"
                onClick={onHide}
                className="btn btn-primary btn-elevate px-5"
            >
                Okay
            </button>
        </Modal.Footer>
    </Modal>
}

export default PaymentAction;